import { render, staticRenderFns } from "./rightImgText.vue?vue&type=template&id=4f76df3b&scoped=true&"
import script from "./rightImgText.vue?vue&type=script&lang=ts&"
export * from "./rightImgText.vue?vue&type=script&lang=ts&"
import style0 from "./rightImgText.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./rightImgText.vue?vue&type=style&index=1&id=4f76df3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f76df3b",
  null
  
)

export default component.exports